'use client';
import { anatomy } from '@zag-js/combobox';

const comboboxAnatomy = anatomy.extendWith("empty");

export { comboboxAnatomy };
